import React, { useState } from 'react';
import { Facebook, Instagram, Youtube } from 'lucide-react';
import { Modal } from './ui/Modal';
import { PrivacyPolicyContent, TermsAndConditionsContent, ContactContent } from './LegalModals';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | 'contact' | null>(null);
  return <>
      <footer className="bg-gradient-to-br from-[#2c4a5c] via-[#1e3a4a] to-[#1a2f3d] border-t border-white/10 pt-16 pb-8" data-id="element-227">
        <div className="max-w-7xl mx-auto px-4" data-id="element-228">
          {/* Main Footer Content */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12" data-id="element-229">
            {/* Brand + Social Media */}
            <div className="text-center md:text-left" data-id="element-230">
              <h3 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-231">
                MÉTODO <span className="text-gold-500" data-id="element-232">CIERRE 90'</span>
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed max-w-md" data-id="element-233">
                El sistema definitivo para profesionales que buscan recuperar el
                control mediante cierres diarios efectivos.
              </p>

              {/* Social Media */}
              <div className="flex gap-4 justify-center md:justify-start" data-id="element-234">
                <a href="https://www.facebook.com/contactokd/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-gold-500 rounded-full flex items-center justify-center transition-all duration-300 group" aria-label="Facebook" data-id="element-235">
                  <Facebook className="w-5 h-5 text-gray-300 group-hover:text-black transition-colors" data-id="element-236" />
                </a>
                <a href="https://www.youtube.com/@mikioscodigital" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-gold-500 rounded-full flex items-center justify-center transition-all duration-300 group" aria-label="YouTube" data-id="element-237">
                  <Youtube className="w-5 h-5 text-gray-300 group-hover:text-black transition-colors" data-id="element-238" />
                </a>
                <a href="https://www.instagram.com/kiosscodigital/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-gold-500 rounded-full flex items-center justify-center transition-all duration-300 group" aria-label="Instagram" data-id="element-239">
                  <Instagram className="w-5 h-5 text-gray-300 group-hover:text-black transition-colors" data-id="element-240" />
                </a>
              </div>
            </div>

            {/* Links */}
            <div className="flex flex-wrap justify-center gap-8 text-gray-300" data-id="element-241">
              <button onClick={() => setActiveModal('privacy')} className="hover:text-gold-500 transition-colors" data-id="element-242">
                Política de Privacidad
              </button>
              <button onClick={() => setActiveModal('terms')} className="hover:text-gold-500 transition-colors" data-id="element-243">
                Términos y Condiciones
              </button>
              <button onClick={() => setActiveModal('contact')} className="hover:text-gold-500 transition-colors" data-id="element-244">
                Contacto
              </button>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="bg-white/5 border border-white/10 rounded-xl p-6 mb-8 text-center" data-id="element-245">
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-246">
              <span className="text-gold-500 font-semibold" data-id="element-247">
                Nota importante:
              </span>{' '}
              Herramienta de organización y hábitos. No reemplaza apoyo
              profesional. Si experimentas estrés crónico severo, consulta con
              un profesional de salud mental.
            </p>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/10 pt-8 text-center text-sm text-gray-400" data-id="element-248">
            <p data-id="element-249">
              Copyright © 2024{' '}
              <span className="text-gold-500 font-semibold" data-id="element-250">
                MÉTODO CIERRE 90'
              </span>{' '}
              todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-251">
        <PrivacyPolicyContent data-id="element-252" />
      </Modal>

      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-253">
        <TermsAndConditionsContent data-id="element-254" />
      </Modal>

      <Modal isOpen={activeModal === 'contact'} onClose={() => setActiveModal(null)} title="Contacto" data-id="element-255">
        <ContactContent data-id="element-256" />
      </Modal>
    </>;
}